import { valibotResolver } from "@hookform/resolvers/valibot";
import { useForm } from "react-hook-form";

import { Button } from "common/components/ui/Button";
import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";

import useAgencyDomainsMutations from "../../../datahooks/useAgencyDomainsMutations";
import useAgencySettingsMutations from "../../../datahooks/useAgencySettingsMutations";
import {
  WhitelabelSlugSchema,
  type WhitelabelSlugSchemaType,
} from "../../../schema";

export default function EditSlug({
  slug,
  closeEditing,
}: {
  slug: string;
  closeEditing: () => void;
}) {
  const { handleSubmit, register } = useForm({
    defaultValues: { slug },
    resolver: valibotResolver(WhitelabelSlugSchema),
  });
  const { updateAgencySettings, isUpdatingAgencySettings } =
    useAgencySettingsMutations();
  const { addAgencyDomain, isAddingAgencyDomain } = useAgencyDomainsMutations();

  function onSubmit({ slug }: WhitelabelSlugSchemaType) {
    updateAgencySettings({ updates: { slug } }).then(() => {
      addAgencyDomain({
        domainName: `${slug}.${import.meta.env.VITE_WHITE_LABEL_DOMAIN}`,
      }).then(closeEditing);
    });
  }

  const isLoading = isUpdatingAgencySettings || isAddingAgencyDomain;

  return (
    <FormField label="Edit subdomain" htmlFor="subdomain-input">
      <form
        className="flex gap-x-2 items-center"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Input
          variant="sm"
          className="w-80"
          id="subdomain-input"
          {...register("slug")}
        />
        <span className="text-xs-medium text-black-500">
          .{import.meta.env.VITE_WHITE_LABEL_DOMAIN}
        </span>
        <Button
          size="sm"
          variant="secondary-black"
          onClick={closeEditing}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          size="sm"
          variant="secondary-purple"
          isLoading={isLoading}
        >
          Save
        </Button>
      </form>
    </FormField>
  );
}
